export default {
  common: {
    english: "English",
    portuguese: "Portuguese",
    spanish: "Spanish",
    vietnamese: "Vietnamese",
    indonesia: "Indonesia",
    hindi: "Hindi",
    logout: "Logout",
    profile: "Profile",
    profiles: "Profiles",
    home: "Home",
    history: 'History',
    update_available: "New version available",
    update_now: "Reload",
    update_later: "Later",
    update_pending: "Update pending: reload when you can",
    statistics: "Statistics",
    evaluations: "Evaluations",
    evaluation: "Evaluation",
    qip: "Quality Improvement Process",
    qip_number: "QIP#",
    instruments: "Instruments",
    instrument: "Instrument",
    action_plan: "Action plan",
    by_category: "By category",
    by_domain: "By domain",
    results: "Results",
    result: "Result",
    users: "Users",
    user: "User",
    countries: "Countries",
    country: "Country",
    regions: "Regions",
    region: "Region",
    zones: "Zones",
    zone: "Zone",
    schools: "Schools",
    school: "School",
    school_program: "School/Program",
    page_rights: "All rights Reserved.",
    powered_by: "Powered by",
    skip_content: "Skip to content",
    eval_subheader: "Program Quality Assessment ",
    close: "Close",
    close_modal: "Close modal",
    cancel: "Cancel",
    loading: "Loading",
    offline_mode: "Offline",
    you_are_offline: "You are offline",
    pending_sync: "{count} pending to sync",
    confirm: "Confirm",
    principles: "Principles",
    identify: "Identify",
    feedback: "Provide feedback",
    return: "Return",
    next: "Next",
    send_email: "Send email",
    change: "Change",
    details: "Details",
    edit: "Edit",
    editing: "Editing",
    delete: "Delete",
    add: "Add",
    save: "Save",
    view: "View",
    back: "Back",
    preview_not_available: "Preview not available",
    text_not_available: "Text not available",
    create: "Create",
    assign: "Assign",
    phone: "Phone",
    email: "Email",
    role: "Role",
    name: "Name",
    undefined: "Undefined yet",
    items_per_page: "Items per page",
    of: "of",
    for: "for",
    and: "and",
    actions: "Actions",
    filter: "Filter",
    assign_all: "Assign all",
    unassign_all: "Unassign all",
    assign_selection: "Assign selection",
    finish: "Finish",
    modality: "Modality",
    level: "Level",
    professions: "Professions",
    public: "Public",
    private: "Private",
    choose: "Choose",
    progress: "Progress",
    help: "Help",
    report: "Report",
    reports: "Reports",
    report_gallery: "Report gallery",
    program_report: "Program report",
    group_report: "Group report",
    section_in_development: "Section under development",
    report_type: "Report type",
    format: "Format",
    created_by: "Created by",
    refresh: "Refresh",
    pagination: "Pagination",
    regenerate: "Regenerate",
    remove: "Remove",
    program: "Program",
    add_program: "Add program",
    status_pending: "Pending",
    status_processing: "Processing",
    status_done: "Done",
    status_partial: "Partial",
    status_failed: "Failed",
    assessment_selection: "Assessment",
    assessment_initial: "Initial assessment",
    assessment_final: "Final assessment",
    assessment_all: "All assessments (average)",
    all_assessments_program: "All assessments of the program",
    start_year: "Start year",
    end_year: "End year",
    domains_all_hint: "Leave empty to include all domains",
    results_reported: "Results reported (domains)",
    indicators_reported: "Indicators reported",
    indicators_select_domain_hint: "Select at least one domain to choose its indicators.",
    select_all: "Select all",
    deselect_all: "Deselect all",
    report_catalog_hint: "Select a program and its evaluation to choose the domains and indicators to report.",
    include_demographics: "Include demographics",
    include_comments: "Include comments",
    report_parameters: "Report parameters",
    all_selected: "All",
    yes: "Yes",
    no: "No",
    report_scope_hint: "Select at least one region, country, zone or school. The report covers the union of everything selected.",
    empty_scope_error: "Select at least one region, country, zone or school.",
    print_section: "Print section",
    print: "Print",
    agreements: "Agreements",
    date: "Date",
    expected_result: "Expected result",
    note: "Note",
    period: "Period",
    options: "Options",
    option: "Option",
    score: "Score",
    total: "Total",
    files: "Files",
    file: "File",
    include_in_report: "Include in report",
    comment: "Comment",
    comments: "Comments",
    description: "Description",
    indicator: "Indicator",
    indicators: "Indicators",
    title: "Title",
    choose_file: "Choose file",
    upload: "Upload",
    download: "Download",
    general: "General",
    complete_field: "Complete field",
    observations: "Observations",
    week: "Week",
    status: "Status",
    category: "Category",
    activity: "Activity",
    action: "Action",
    done: "Done",
    not_done: "Not done",
    in_progress: "In progress",
    completed: "Completed",
    complete: "Complete",
    incomplete: "Incomplete",
    postponed: "Postponed",
    cancelled: "Cancelled",
    pending: "Pending",
    blocked: "Blocked",
    in_person: "In person",
    virtual: "Virtual",
    south_america_and_caribbean: "Latin America and the Caribbean",
    europe: "Europe",
    asia: "Asia",
    stage: "Stage",
    stages: "Stages",
    outcome: "Outcome",
    outcomes: "Outcomes",
    expansion: "Expansion",
    performance: "Performance",
    transformation: "Transformation",
    innovation: "Innovation",
    domain: "Domain",
    domains: "Domains",
    evidence: "Evidence",
    evidences: "Evidences",
    optional: "Optional",
    accept: "Accept",
    enabled: "Enabled",
    disabled: "Disabled",
    loading_data: "Loading data",
    no_data_available: "No data available",
    notifications: "Notifications",
    help_menu: "Help menu",
    faq: "FAQ",
    user_guides: "User Guides",
    general_feedback: "General Feedback",
    report_a_bug: "Report a Bug",
    feature_request: "Feature Request",
    change_theme: "Change theme",
    dark_theme: "Dark theme",
    light_theme: "Light theme",
    user_menu: "User menu",
    change_language: "Change language",
    unassigned: "Unassigned",
    unread: "unread",
    understand: "Understand",
    ok: 'OK',
    reject: "Reject",
    validated: "Validated",
    closed: "Closed",
    index: "Index",
    show_info: "Show info",
    new: "New",
    year: "Year",
    accountable: "Accountable",
    deadline: "Deadline",
    assesment: "Assesment",
    assesments: "Assesments",
    download_csv: "Download CSV",
    download_svg: "Download SVG",
    download_png: "Download PNG",
    first_page: "First page",
    previous_page: "Previous page",
    next_page: "Next page",
    last_page: "Last page",
    other: "Other",
    links: "Links",
    link: "Link",
    clear_all: "Clear all",
    location: "Location",
    urban: "Urban",
    rural: "Rural",
    male: "Male",
    female: "Female",
    duplicate: "Duplicate",
    actor: "Actor",
    model: "Model",
    record_id: "Record ID",
    record_repr: "Record",
    timestamp: "Date & time",
    changes: "Changes",
    show_all_changes: "Show all",
    show_less: "Show less",
    select_filters: "Select filters...",
    filter_object_id: "By specific record",
    filter_actor: "By user (id)",
    filter_action: "By action type",
    filter_date_from: "Date from",
    filter_date_to: "Date to",
    filter_school: "By school",
    offline_changes: "Offline changes",
  },
  countries: {
    AM: "Armenia",
    AR: "Argentina",
    BO: "Bolivia",
    BR: "Brazil",
    CL: "Chile",
    CO: "Colombia",
    CR: "Costa Rica",
    CU: "Cuba",
    DO: "Dominican Republic",
    EC: "Ecuador",
    GD: "Grenada",
    GF: "French Guiana",
    GT: "Guatemala",
    GY: "Guyana",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    JM: "Jamaica",
    KZ: "Kazakhstan",
    MX: "Mexico",
    NI: "Nicaragua",
    PA: "Panama",
    PE: "Peru",
    PR: "Puerto Rico",
    PY: "Paraguay",
    RS: "Serbia",
    SR: "Suriname",
    SV: "El Salvador",
    UY: "Uruguay",
    VE: "Venezuela",
    IN: "India",
    IND: "Indonesia",
    VI: "Vietnam",
  },
  auth_users: {
    login_greetings: "Perkins Quality Assessment!",
    login_description: "Login with your account",
    login_email: "Email or user",
    login_password: "Password",
    login_forgot_password: "Forgot your password?",
    login_submit: "Login",
    forgot_password_description: "Enter your email address and we will send you a recovery link",
    recover_title: "Recover password",
    recover_description: "Enter your new password",
    recover_submit: "Change",
    recover_invalid_token: "Invalid or expired token",
    recover_invalid_token_description: "The token is invalid or has expired. Please request a new password reset.",
    recover_password_changed: "Password changed correctly",
    recover_password_changed_description: "You can now login with your new password",
    role_admin: "Administrator",
    role_regional: "Reviewer",
    role_country: "Regional administrator",
    role_school: "Assessor",
    assessors: "Assessors",
    role_auditor: "Auditor",
    change_password: "Change user password",
    edit_user_info: "Edit user data",
    previous_password: "Previous password",
    password: "Password",
    new_password: "New password",
    repeat_new_password: "Repeat new password",
    confirm_password: "Confirm password",
    create_user: "Create user",
    edit_user: "Edit user",
    search_user: "Search by user name",
    full_name: "Full name",
    username: "Username",
    change_role: "Change role",
    is_super_admin: "Is super admin",
    change_password_q: "Change password?",
    change_role_advice: "Changing the role would eliminate relationships with countries, regions, and schools.",
    create_region: "Create region",
    create_zone: "Create zone",
    create_school: "Create school",
    create_assessor: "Create assessor",
    create_report: "Create report",
    assigned_countries: "Assigned Countries",
    assigned_regions: "Assigned Regions",
    assigned_zones: "Assigned Zones",
    assigned_schools: "Assigned Schools",
    no_assigned_countries: "There are no assigned countries to this user",
    no_assigned_regions: "There are no assigned regions to this user",
    no_assigned_zones: "There are no assigned zones to this user",
    no_assigned_schools: "There are no assigned schools to this user",
    assigned_assessors: "Assigned Assessors",
    no_assigned_assessors: "No assessors assigned to this school",
    delete_user_q: "Are you sure you want to delete this user?",
    delete_school_q: "Are you sure you want to delete this school?",
    delete_region_q: "Are you sure you want to delete this region?",
    delete_zone_q: "Are you sure you want to delete this zone?",
    delete_report_q: "Are you sure you want to delete this report?",
    school_name: "School name",
    project_name: "Project name",
    region_name: "Region name",
    zone_name: "Zone name",
    type_of_management: "Type of management",
    type_of_school: "Type of school",
    school_type: "School type",
    school_level: "School level",
    number_of_students: "Number of students",
    number_of_teachers: "Number of teachers",
    students_with_disabilities: "Students with disabilities",
    students_with_mult_disabilities: "Students with multiple disabilities (not visually impaired)",
    students_with_visual_disabilities: "Students with visual disabilities or blind",
    students_with_deafblindness: "Students with deafblindness",
    students_without_disabilities: "Students without disabilities",
    number_of_other_professionals: "Number of other professionals",
    total_staff: "Total staff",
    preschool: "Pre-school",
    primary_school: "School",
    secondary_school: "High school",
    regular_education: "Regular education",
    special_education: "Special education",
    community_center: "Community center",
    hospital_home_education: "Hospital home education",
    early_childhood_center: "Early childhood center",
    search_by_school_name: "Search by school name",
    search_by_region_name: "Search by region name",
    search_by_zone_name: "Search by zone name",
    search_by_country_name: "Search by country name",
    no_notifications: "No notifications",
    read_more: "Read more",
    age_range: "Age range",
    characterization: "Socioeconomic characterization",
    age_range_0: "Early childhood (0-6 y.o.)",
    age_range_1: "Children (7-14 y.o.)",
    age_range_2: "Youth (15-24 y.o.)",
    characterization_0: "Low income",
    characterization_1: "Middle income",
    characterization_2: "High income",
    precentage_of_minority: "Percentage of minority",
    students_with_mult_no_deafblind: "Students with multiple disabilities and visual impairment (not deafblind)",
  },
  policy: {
    title: "Privacy Policies"
  },
  home: {
  },
  evaluations: {
    general_status_1: "Assessment in progress",
    general_status_2: "Assessment pending review",
    general_status_3: "Action plan in progress",
    general_status_4: "Action plan pending review",
    general_status_5: "Closed",
    general_status_6: "Action plan approved",
    general_status_7: "Assessment under review",
    general_status_8: "Assessment approved",
    general_status_9: "Assessment completed",
    general_status_10: "Developing the action plan",
    general_status_11: "Action plan under review",
    general_status_12: "Implementing action plan",
    general_status_13: "Closed without action plan",
    assessment: "Assessment",
    base_line: "Baseline",
    second_evaluation: "Second assessment",
    third_evaluation: "Third assessment",
    enable_action_plan: "Enable action plan",
    enable_action_plan_q: "Are you sure you want to enable the action plan? The information loaded in this assessment will no longer be editable.",
    send_to_review: "Send to review",
    in_review: "In review",
    stage_approved: "Stage approved",
    stage_in_review: "Stage in review",
    who_can_validate: "Who can validate",
    can_validate_this_stage: "Can validate this stage",
    sent_to_review_by: "Sent to review by",
    no_stages_in_review: "There are no stages in review",
    no_eligible_reviewers: "No reviewer or regional administrator is available for this stage. An administrator can validate it.",
    admins_can_always_validate: "Administrators can also validate any stage in review.",
    ready_to_review: "ready to review",
    stage_approved_title: "Stage {stage} approved",
    delete_assessment: "Delete assessment",
    delete_assessment_q: "Are you sure you want to delete this assessment?",
    delete_assessment_warning: "All evidence and scores loaded for this assessment will be permanently lost.",
    enable_action_plan_blocked: "The action plan could not be enabled:",
    close_without_action_plan: "Close without action plan",
    close_without_action_plan_q: "Are you sure you want to close this assessment without an action plan?",
    close_without_action_plan_warning: "The assessment will be closed and no action plan will be created for it. The information loaded in this assessment will no longer be editable.",
    close_without_action_plan_blocked: "The assessment could not be closed:",
    reopen_assessment: "Reopen assessment",
    reopen_assessment_q: "Are you sure you want to reopen this assessment?",
    reopen_assessment_warning: "The action plan generated for this assessment and all information loaded in it will be permanently deleted.",
    open_new_assessment: "Open new assessment",
    reactivate_action_plan: "Reactivate action plan",
    reactivate_action_plan_confirm: "This will reopen the validated action plan for editing. Continue?",
    open_new_assessment_confirm: "This will open a new assessment from the closed one. Continue?",
    finalize_qip: "Finalize Quality Improvement Process",
    reopen_qip: "Reopen Quality Improvement Process",
    finalize_qip_confirm: "This will mark the Quality Improvement Process as finalized. Continue?",
    reopen_qip_confirm: "This will reopen the finalized Quality Improvement Process. Continue?",
    offline: "Offline",
    offline_filter_downloaded: "Offline",
    download_offline: "Download for offline",
    offline_download_cta: "Download",
    offline_downloaded_by_you: "Downloaded for offline",
    offline_downloaded: "Downloaded",
    offline_downloaded_by: "Downloaded by",
    offline_last_download: "Last download",
    offline_view: "Offline view",
    offline_notice: "This is the offline copy of the assessment. Sending stages to review and any approval or unlocking actions are done online: sync your changes with the Sync button to unlock this assessment for online work.",
    offline_sync: "Sync",
    offline_sync_title: "Sync changes to the server?",
    offline_sync_intro: "You are about to upload your local changes ({count} pending) to the server. Before continuing:",
    offline_sync_point_connection: "make sure you have a stable internet connection,",
    offline_sync_point_unlock: "after syncing, this assessment is unlocked for online use,",
    offline_sync_point_redownload: "to work offline again you will need to download it once more.",
    offline_sync_warning: "The server will apply and recalculate your changes and become the source of truth. This action cannot be undone from here.",
    offline_sync_cta: "Sync now",
    offline_sync_success: "Your changes were synced. This assessment is now unlocked for online use.",
    offline_sync_partial: "Your changes were synced, but the server could not apply {count} item(s). Review the assessment online.",
    offline_sync_mode_label: "What do you want to do with your offline changes?",
    offline_sync_mode_apply: "Sync and apply my changes",
    offline_sync_mode_release: "Release the assessment without applying my changes",
    offline_release_own_notice: "Your offline changes will not be applied: they will be saved in Offline changes, where they can be reviewed or applied later. The assessment is released for online work and for other users.",
    offline_release_own_cta: "Release without applying",
    offline_release_own_success: "The assessment was released. Your offline changes were not applied and were saved in Offline changes.",
    offline_evidence_disabled: "You are working on the offline copy of this assessment: evidence can't be uploaded, edited or deleted. Sync your changes and do it online.",
    offline_links_disabled: "You are working on the offline copy of this assessment: links can't be added or deleted. Sync your changes and do it online.",
    offline_files_need_connection: "No connection: previewing and downloading evidence files is available once you are back online.",
    offline_sync_for_review_aria: "Sync your offline changes for administrator review",
    offline_sync_for_review_notice: "This assessment is no longer downloaded by you (it was released by an administrator or its QIP was deleted). Sync your offline changes anyway: they will not be applied to the assessment directly, they will be saved for an administrator to review.",
    offline_pending_review_title: "Offline changes pending sync",
    offline_pending_review_msg: "These assessments are no longer downloaded by you (for example, their QIP was deleted) but have unsynced changes on this device. Sync them: your changes will not be applied, they will be saved for an administrator to review.",
    offline_auto_sync_done: "An administrator released {count} assessment(s) you had offline with unsynced changes. Your changes were sent automatically and saved for an administrator to review; they were not applied to the assessment(s).",
    offline_sync_not_applied: "This assessment is no longer downloaded by you, so your changes were not applied. They were saved for an administrator to review.",
    offline_sync_no_connection: "No internet connection. Connect to a stable network and try syncing again.",
    offline_in_use_by: "In offline use by {name}",
    offline_readonly_by: "is working on this assessment offline (read-only).",
    offline_download_success: "Assessment downloaded for offline use.",
    offline_error_already_by_you: "You have already downloaded this assessment for offline use.",
    offline_error_already_downloaded: "This assessment is already downloaded offline by another user.",
    offline_error_limit_reached: "You can only have 3 assessments downloaded offline at the same time.",
    offline_error_generic: "The assessment could not be downloaded for offline use.",
    offline_error_snapshot: "The assessment was locked but its data could not be saved for offline use. Try again.",
    offline_limit_reached_hint: "You already have 3 assessments downloaded offline.",
    offline_redownload: "Re-download",
    offline_redownload_hint: "This assessment is reserved for your offline use but its data is missing from this device (browser storage may have been cleared). Re-download it to work offline again.",
    offline_redownload_confirm_title: "Download this assessment again?",
    offline_redownload_confirm_intro: "You already downloaded this assessment for offline use ({date}), but its data is not on this device. This can happen because:",
    offline_redownload_reason_other_device: "it was downloaded on another device or browser,",
    offline_redownload_reason_storage: "the browser storage or cache was cleared,",
    offline_redownload_reason_reinstall: "the browser was reinstalled or reset.",
    offline_redownload_confirm_warning: "If you download it again here, the offline progress made on the other device or browser will be lost when you sync from this one.",
    offline_redownload_pending_warning: "This device has {count} unsynced change(s) for this assessment. Downloading it again discards them.",
    offline_redownload_confirm_cta: "Download again",
    offline_home_title: "Offline work",
    offline_home_subtitle: "Assessments downloaded to this device",
    offline_no_downloads: "You have no assessments downloaded for offline use.",
    offline_downloaded_at: "Downloaded {date}",
    offline_open_edit: "Open to edit",
    offline_open_soon: "Editing offline arrives in the next release",
    offline_discard: "Discard local copy",
    offline_discard_title: "Discard local copy?",
    offline_discard_msg: "You will lose any offline changes for this assessment. This does not release the assessment on the server.",
    offline_back_online: "You are back online. You can return to the platform.",
    offline_go_to_platform: "Go to assessments",
    offline_release: "Release",
    offline_release_aria: "Release this assessment from {name}'s offline use",
    offline_release_title: "Release this assessment from offline use?",
    offline_release_msg: "{name} has this assessment downloaded for offline work. Releasing it makes it editable online again. {name} will be notified by email and in the app; if they sync pending changes afterwards, those changes will not be applied but saved in Offline changes for review.",
    offline_release_success: "The assessment was released from offline use.",
    offline_release_error: "The assessment could not be released. Refresh the list and try again.",
    offline_payloads_subtitle: "Offline changes as they were sent by each user: synced, discarded after losing the offline lock, or replayed by an administrator.",
    offline_payloads_filter_qip: "QIP",
    offline_payloads_filter_user: "User",
    offline_payloads_filter_source: "Type",
    offline_payloads_line_chip: "Assessment #{id}",
    offline_payloads_clear_line: "Remove assessment filter",
    offline_payloads_filter_by_line: "Show only assessment #{id}",
    offline_payloads_col_source: "Type",
    offline_payloads_col_assessment: "School / QIP",
    offline_payloads_col_user: "User",
    offline_payloads_col_contents: "Contents",
    offline_payloads_col_result: "Result",
    offline_payloads_source_synced: "Synced",
    offline_payloads_source_discarded: "Discarded",
    offline_payloads_source_replayed: "Replayed",
    offline_payloads_sent_by: "sent by {name}",
    offline_payloads_scores: "{count} score(s)",
    offline_payloads_comments: "{count} comment(s)",
    offline_payloads_demographics: "demographics",
    offline_payloads_errors: "{count} item(s) failed",
    offline_payloads_applied: "Applied",
    offline_payloads_view_aria: "View offline changes #{id}",
    offline_payloads_detail_title: "Offline changes #{id}",
    offline_payloads_replayed_from: "Replayed from",
    offline_payloads_json: "JSON sent",
    offline_payloads_tab_summary: "Summary",
    offline_payloads_no_changes: "This batch has no changes.",
    offline_payloads_action_created: "New",
    offline_payloads_action_updated: "Changed",
    offline_payloads_action_deleted: "Cleared",
    offline_payloads_comment_add: "Added",
    offline_payloads_comment_edit: "Edited",
    offline_payloads_comment_remove: "Removed",
    offline_payloads_comment_ref: "Comment #{id}",
    offline_payloads_copy: "Copy",
    offline_payloads_copied: "JSON copied to the clipboard.",
    offline_payloads_download: "Download",
    offline_payloads_replay: "Apply to the assessment",
    offline_payloads_replay_title: "Apply these changes to the assessment?",
    offline_payloads_replay_warning: "The scores and student demographics in this JSON will overwrite the current data of the assessment, and its progress and stages will be recalculated. Comments are added with their original author. This cannot be undone.",
    offline_payloads_replay_success: "The changes were applied to the assessment.",
    offline_payloads_replay_partial: "The changes were applied, but {count} item(s) could not be applied.",
    offline_payloads_replay_error: "The changes could not be applied.",
    offline_payloads_replay_error_deleted: "The assessment of these changes no longer exists.",
    offline_payloads_replay_error_closed: "The assessment is closed: changes cannot be applied to it.",
    offline_payloads_replay_error_downloaded: "The assessment is currently downloaded offline by a user. Release it first from the QIP list.",
    offline_lock_toggle_aria: "Lock offline mode",
    offline_lock_title: "Lock offline mode",
    offline_lock_desc: "This forces the app into offline mode so an intermittent or weak connection can't trigger requests you didn't intend. Your work stays on this device. Whenever you have a connection, you can return to online mode from the offline screen.",
    offline_lock_cta: "Lock offline mode",
    finalized: "Finalized",
    finalized_on: "Finalized on",
    finalized_by: "Finalized by",
    finalize_blocked: "This Quality Improvement Process can't be finalized yet. Complete the following first:",
    evaluation_review: "Assessment review",
    evaluation_review_approved: "Assessment review approved",
    evaluation_review_rejected: "Assessment review rejected",
    action_plan_review: "Action plan review",
    action_plan_review_approved: "Action plan review approved",
    action_plan_review_rejected: "Action plan review rejected",
    validate_review: "Validate review",
    cancel_review: "Cancel review",
    complete_to_review: "Not ready for review",
    review_readiness: "Review readiness",
    locate_in_table: "Show in table",
    clear_highlight: "Hide highlight",
    select_stages_to_send: "Select stages to send to review",
    select_stages_to_validate: "Select stages to validate",
    select_stages_to_cancel: "Select stages to cancel review",
    select_stages_to_invalidate: "Select stages to invalidate",
    confirm_cancel_review: "Confirm cancellation",
    invalidate_review: "Invalidate stage",
    confirm_invalidate: "Confirm invalidation",
    invalidate_review_warning: "The selected stages will lose their validation and return to editable, as when sending to review. This action only affects the validation.",
    validation_message_placeholder: "Write a message for the reviewer (optional)",
    review_message_placeholder: "Write a message for the evaluator (optional)",
    review_message: "Review message",
    validation_messages: "Validation messages",
    review_approved: "Approved",
    review_rejected: "Rejected",
    general_results: "General results",
    school_evolution: "School evolution",
    print_evaluation: "Print assessment",
    visualization: "Assessment visualization",
    view_visualization: "Visualization",
    filter_by_line: "Filter by assessment",
    all_lines: "All lines",
    all_stages: "All stages",
    download_report: "Download",
    download_xls: "Excel (.xlsx)",
    download_docx: "Word (.docx)",
    download_pdf: "PDF",
    download_all: "Download all formats",
    generate_report: "Generate",
    generate_xls: "Excel (.xlsx)",
    generate_docx: "Word (.docx)",
    generate_pdf: "PDF",
    generate_all: "Generate all formats",
    report_generating: "Generating…",
    report_generation_started: "Report generation started. This may take a moment.",
    report_generation_failed: "Report generation failed. Please try again.",
    report_download_error: "Could not download the report. Please try again.",
    program_report_limit_reached: "You can select up to {max} programs per report.",
    delete_report_q: "Are you sure you want to delete this report?",
    report_deleted: "Report deleted.",
    report_delete_error: "Could not delete the report. Please try again.",
    report_select_line_and_stage: "Select at least one assessment and one stage before generating a report.",
    no_score_selected: "No score selected",
    evidence_and_links: "Evidence & links",
    no_evidence_for_domain: "No evidence loaded for this domain.",
    no_links_for_domain: "No links loaded for this domain.",
    visualization_empty: "Select at least one assessment and one stage to display the assessment.",
    no_general_comments: "No general comments were found for this assessment.",
    no_indicator_comments: "No comments were found.",
    print_charts: "Print charts",
    category_score: "Category score",
    rank_top: "Highest scores",
    rank_bottom: "Lowest scores",
    stage_scores: "Score by stage",
    stage_contribution: "Contribution to total score",
    indicator_not_applicable: "Not applicable",
    indicator_no_results: "No results loaded yet",
    indicator_not_available: "Not available for this domain",
    select_assessment: "Assessment",
    select_stage: "Stage",
    distribution_of_criteria: "Distribution of assessment criteria",
    print_helper_title: "Having trouble printing the graphics?",
    delete_qip: "Delete Quality Improvement Process",
    create_qip: "Create Quality Improvement Process",
    edit_qip: "Edit Quality Improvement Process",
    general_comments: "General comments",
    demographics: "Demographics",
    student_demographics: "Student demographics",
    edit_student_demographics: "Edit student demographics",
    add_comment: "Add comment",
    add_description: "Add description",
    edit_description: "Edit description",
    save_comment: "Save comment",
    open_comments: "Open comments",
    close_comments: "Close comments",
    delete_comment: "Delete comment",
    confirm_comment_delete_q: "Are you sure you want to delete this comment?",
    add_evidence: "Add evidence",
    delete_file: "Delete file",
    confirm_file_delete_q: "Are you sure you want to delete this file?",
    upload_evidence: "Upload evidence",
    file_size_hint: "*Images (jpg, jpeg, png) up to 6 MB, files (PDF, xlsx, xls, csv, ppt and pptx) up to 10 MB and videos (mp4) up to 25 MB",
    uploaded_evidence: "Uploaded evidence",
    stage_1: "Stage 1: Change",
    stage_2: "Stage 2: Transformation",
    stage_3: "Stage 3: Innovation",
    current_stage: "Current stage",
    stage_view: "Stage view",
    filter_by: "Filter by",
    filter_by_stage: "Filter by stage",
    show_all_stages: "Show all stages",
    stage_promotion_title: "Stage Promotion",
    stage_promotion_message: "Your assessment has been promoted:",
    stage_visibility_info: "The domain visibility will be updated according to the new assessment stage",
    stage_demotion_title: "Stage Reverted",
    stage_demotion_message: "The assessment score no longer meets the requirements. It has been returned to:",
    stage_demotion_visibility_info: "The domain visibility will be updated to reflect the current assessment stage",
    stage_3_locked_warning: "Stage 3 has been unlocked by score, but it won't be visible until Stage 1 is completed, submitted for review, and approved.",
    to_domain: "Go to domain",
    has_comment: "has comment",
    edit_comment: "Edit comment",
    full_comment: "Full comment",
    delete_evaluation_q: "Are you sure to delete this Quality Improvement Process?",
    delete_note_q: "Are you sure you want to delete this note?",
    download_files_hint: "Download by clicking on the file icons",
    download_files_size: "The file you want to upload must have one of the following extensions and maximum sizes",
    theoretical_weight: "Theoretical weight",
    indicator_required1: "Must register some indicator",
    indicator_required2: "to be able to visualize graphs",
    by_indicator: "By indicator",
    by_evaluation: "By Quality Improvement Process",
    by_modality: "By modality",
    by_management: "By management",
    score_by_school: "Score by school",
    schools_by_stage: "Schools by stage",
    by_school: "By school",
    by_country: "By country",
    by_region: "By region",
    by_zone: "By zone",
    by_continent: "By continent",
    indicator_score: "Indicator score",
    questions_title: "Questions & answers",
    delete_answer_q: "Are you sure you want to delete this answer?",
    delete_goal_q: "Are you sure you want to delete this goal?",
    delete_result_q: "Are you sure you want to delete this result?",
    delete_observation_q: "Are you sure you want to delete this observation?",
    delete_action_q: "Are you sure you want to delete this action?",
    goal: "Goal",
    add_goal: "Add goal",
    goal_to_achieve: "Goal to be achieved",
    question_1: "What are the program’s strengths found during the assessment? Which domains do they belong to?",
    question_2: "What needs or gaps were found during the assessment? Which domains do they belong to?",
    question_3: "What are the motivations that could drive the team during this period?",
    question_4: "Which of the previous needs or gaps should be prioritized in the action plan?",
    question_5: "What do you expect to achieve regarding those needs or gaps?",
    question_6: "What resources have to be put in place to carry out the action plan successfully? Are they or are they going to be really available?",
    question_7: "What challenges or obstacles might come up when carrying out the action plan?",
    activity_category_1: "Follow-up meetings.",
    activity_category_2: "Communications by e-mail, WhatsApp.",
    activity_category_3: "Monitoring the implementation of content received since the academy's formation.",
    activity_category_4: "Monitoring of singular/distinctive activities, practices referring to individual cases.",
    activity_category_5: "Other education.",
    activity_category_6: "Other activities.",
    expected_outcome: "Expected outcome",
    create_observation: "Create new observation",
    no_observations: "There is no observations loaded yet",
    no_actions_assigned: "There is no actions loaded yet",
    create_action: "Create new action",
    validate_action_plan: "Validate action plan",
    validate_action_plan_confirm: "As admin, this validates the action plan without requiring it to be completed. Continue?",
    action_status: "Action status",
    action_category: "Action category",
    next_agreements: "Next agreements",
    no_action_plan: "This assessment does not have an action plan",
    print_helper_description_1: "When you press the print button and go to the print interface, you may see differences in the size and layout of the graphics and typography, depending on the web browser you use (we recommend using Chrome or Firefox).",
    print_helper_description_2: "There may also be variations depending on the zoom you have set in your browser, it is recommended to use the default value (100%) when pressing the \"print graphics\" button.",
    print_helper_description_3: "In any case, when you press the button, the print modal will open, which is a component that does not depend on our application, but on the browser.",
    print_helper_description_4: "In all browsers you will find here a different version of this functionality, but all have some useful functions with which you can give more customization to the layout and size of the elements.",
    print_helper_description_5: "For example, you can adjust the page margins, select whether you want to print in portrait or landscape orientation, and decide whether you want to print the browser's headers and footers.",
    print_helper_description_6: "In addition, some browsers offer the option to scale the page content to fit the paper size. This can be useful if you find that the page content is too large or too small when printed.",
    print_helper_subtitle: "Google Chrome example",
    actions_to_goal: "Actions to achieve the goal",
    uploaded_links: "Uploaded links",
    add_link: "Add link",
    delete_only_active_line: "Delete only active line",
    confirm_link_delete_q: "Are you sure you want to delete this link?",
    reviewer_agreement_text: "By approving this assessment, I certify that I have thoroughly reviewed all assessment sections, supporting evidence, and comments submitted by the assessor.\n I confirm that the assessment meets our established quality standards, that all information is complete and accurate to the best of my knowledge.",
    action_plan_reviewer_agreement_text: "By approving this action plan, I certify that I have thoroughly reviewed the entire action plan, the analysis of the assessment results, the goals set by the team, and the actions planned to achieve them. \n I confirm that the action plan meets our established quality standards, that all information is complete and accurate to the best of my knowledge.",
    reviewer_agreement_positive: "I confirm",
    reviewer_agreement_negative: "Check to confirm",
    observations: "Observations and Outcomes",
    description: "Description",
    action_plan_in_implementation: "The action plan was approved and is now in implementation.",
    in_implementation: "In implementation",
    no_comments: "No comments yet",
    no_links_loaded: "No links loaded yet",
    link_url: "URL",
    close_action_plan: "Close action plan",
    close_action_plan_confirm: "Closing the action plan requires all activities to be completed or cancelled and at least one link loaded. Do you want to continue?",
    close_action_plan_blocked: "The action plan could not be closed:",
    implement: "Implement",
    is_editing_assessment: "is editing this assessment",
    duplicate_qip_q: "Are you sure you want to duplicate this Quality Improvement Process?",
    duplicate_qip: "Duplicate Quality Improvement Process",
    performance_vs_expansion: "Performance vs expansion",
    contribution: "Contribution",
    activity_log: "Activity log",
    activity_log_empty: "No activity recorded yet for this Quality Improvement Process.",
    log_LINE_OPENED: "Assessment opened",
    log_LINE_CLOSED: "Assessment closed",
    log_LINE_CLOSED_NO_PLAN: "Assessment closed without action plan",
    log_STAGE_SENT_TO_REVIEW: "Stage {stage} sent to review",
    log_STAGE_REVIEW_CANCELLED: "Stage {stage} review cancelled",
    log_STAGE_APPROVED: "Stage {stage} approved",
    log_STAGE_REJECTED: "Stage {stage} rejected",
    log_AP_OPENED: "Action plan opened",
    log_AP_CLOSED: "Action plan closed",
    log_AP_SENT_TO_REVIEW: "Action plan sent to review",
    log_AP_REVIEW_CANCELLED: "Action plan review cancelled",
    log_AP_APPROVED: "Action plan approved",
    log_AP_REJECTED: "Action plan rejected",
    qip_ordinal: "{ordinal}",
    no_assessments: "No Quality Improvement Processes for this school",
    lines_and_action_plan: "Assessments & action plan",
    open_assessment: "Open assessment",
    open_action_plan: "Open action plan",
    assessments_count: "Assessments",
  },
  instruments: {
    pqi_v2: "Program Quality Assessment 2025",
    instrument_used: "Instrument used",
    change_score: "Change score",
    select_option_of: "Select option of",
    options_e_A: "Not applicable",
    options_e_B: "Evidence of a good practice was not found",
    options_e_C: "Localized",
    options_e_D: "Scaling-up",
    options_e_E: "Widespread",
    options_e_F: "Policy",
    options_e_G: "Systematic replication",
    options_p_A: "Not applicable",
    options_p_B: "Evidence of a good practice was not found",
    options_p_C: "Emerging good practice",
    options_p_D: "Consistent good practice",
    options_p_E: "Consolidated good practice",
    options_p_F: "Effective good practice",
    options_p_G: "Continuous quality improvement",
    domain_title_1: "Program Planning and Classroom Organization",
    domain_description_1: "Program Planning and Classroom Organization are key areas that allow programs to address the different characteristics and needs of the diverse population of learners with disabilities. Since each learner is unique, teaching should be individualized and based on the specific needs of each individual learner. These areas allow program staff to implement a learner-centered approach, in which educational practices are individualized, flexible, respectful of, and responsive to each learner.",
    domain_title_2: "Environment and Learning Materials",
    domain_description_2: "Adapted and accessible environments and materials are important to maximize learning. Physical barriers, poor accessibility conditions, and lack of access to appropriate learning materials are serious barriers to learning for learners with disabilities.",
    domain_title_3: "Assessment and Progress Monitoring",
    domain_description_3: "Assessment is an important tool that contributes to a better understanding of each learner, providing relevant information to make decisions about teaching methods and supports.  Formal and non-formal tools are essential components in the educational process of students with and without disabilities. Progress Monitoring involves regularly keeping track of learner progress in meeting goals in order for staff to effectively plan for instruction.",
    domain_title_4: "Communication and Social Relationships",
    domain_description_4: "Communication is the foundation of all learning and a human right.  The development of communication and social skills for learners with disabilities is key for their meaningful learning and socialization and therefore critical to quality education.  Program staff should be fluent in different modes of communication and support a multi-modal communication approach so they enable their learners to communicate in meaningful and efficient ways.",
    domain_title_5: "Curriculum and Instruction",
    domain_description_5: "Meaningful curriculum is core to learning.  Accessing curriculum is key for learners with disabilities so they can have an education on an equal basis with others.  All indicators and their components are based on the principals of universal design for learning and differentiated instruction.  The “Expanded Core Curriculum” (ECC) addresses additional essential learning areas for learners with disabilities.  Functional adaptations to curriculum are also essential so learners can acquire the necessary non-academic skills for achieving a fulfilling and independent life.  Effective and individualized instructional supports, delivered by all staff, are essential for learner learning.",
    domain_title_6: "Family Engagement",
    domain_description_6: "Building partnerships with families is essential to quality programs that serve learners with disabilities.  Families know their children best and play a key role in their education.  It is important to include, support and empower families by building trusting relationships, including families as partners in the education of their children, maintaining open communication with families, and offering trainings.",
    domain_title_7: "Administration and Support",
    domain_description_7: "Management and administration play a key role in quality programs as they determine the culture and approach to education.  An enabling administration is one that promotes and supports the right to education of all learners at all levels.  A supportive administration also supports program staff and their continuing professional development.",
    outcome_1_1: "Learners attend program regularly on a full time basis.",
    outcome_1_2: "Learners' needs/strengths/preferences/ interests are addressed by consistent classroom staff who are prepared to support them.",
    outcome_1_3: "Each learner's individual processes are supported through collaborative learning among peers, where personal talents are highlighted to respond to the needs, preferences and interests of each one.",
    outcome_1_4: "Learning is supported through consistent schedules that address each individual's learning needs.",
    outcome_1_5: "Learners participate in a daily schedule of activities that appropriately supports their learning.",
    outcome_1_6: "Learners' relevant information is considered in the development of all activities and in any transitions to a new program/teacher.",
    indicator_1_1_s1: "The program complies with Ministry of Education (or other relevant governmental agency) regulations on school attendance.",
    indicator_1_1_s2: "Learners are scheduled to come to program the same length of time as learners without disabilities.",
    indicator_1_1_s3: "Learners actually come to program same number of days and length of time as learners without disabilities (regular program attendance).",
    indicator_1_2_s1: "Classroom staff are consistent.",
    indicator_1_2_s2: "Classroom staff are consistent and adequately prepared to support the learning needs, strengths, preferences  and interests of the learners.",
    indicator_1_2_s3: "Classroom staff are consistent, adequately prepared to support the learning needs, strengths, preferences  and interests of the learners, and staff support each other in meeting each individual's learning needs/ strengths/ preferences/ interests.",
    indicator_1_3_s1: "Learners are grouped into age-appropriate classes considering their chronological age.",
    indicator_1_3_s2: "Learners are grouped into age-appropriate classes considering their chronological age, and class groupings consider the learning needs/ strengths/ preferences/ interests of each learner.",
    indicator_1_3_s3: "Learners are grouped into age-appropriate classes considering their chronological age, class groupings consider the learning needs/ strengths/ preferences/ interests of each learner, and class groupings are reviewed and adjusted as indicated on an annual basis.",
    indicator_1_4_s1: "Class schedules are flexible to allow sufficient time for learners to actively participate in self-help activities.",
    indicator_1_4_s2: "Class schedules are consistent and designed to support students, providing stability through accessible schedules (visual/ tactile/ auditory) that are posted and used by staff and learners throughout the day.",
    indicator_1_4_s3: "The organization of the day is flexible, with sufficient time for transitions between activities to allow for an understanding of the transition and for learners to participate calmly and safely.",
    indicator_1_5_s1: "There is a class schedule and it is followed consistently.",
    indicator_1_5_s2: "Learners have access to their schedule and use their schedule to understand and anticipate activities. Predictable routines are established through the use of visual/ tactile/ auditory schedules that are posted and used by staff and learners throughout the day.",
    indicator_1_5_s3: "Class schedules allow sufficient time for learners to actively participate in all activities, providing sufficient time for transitions between activities to allow for calm understanding and participation by the learners.",
    indicator_1_6_s1: "Activities have a clear beginning, middle and end.",
    indicator_1_6_s2: "The day is organized in a way that creates a flow, connecting activities to one another (for example, writing a list of items to be purchased for a cooking activity, going to the store to buy them, completing the cooking activity, writing about the activity in a journal)",
    indicator_1_6_s3: "Staff embed instruction and targeted goals into naturally occurring opportunities for learning, for example by working on sign language, social and fine motor skills while participating in snack time; by addressing orientation and mobility, functional numeracy and communication during a trip to the local market.",
    indicator_1_7_s1: "Files are maintained for each learner, containing assessment and educational reports (e.g. communication, literacy, numeracy, daily living skills, etc.), as well as relevant medical reports (e.g. ophthalmology/ optometry, audiology or functional evaluations as available).",
    indicator_1_7_s2: "There are planned opportunities for staff to support each other and share relevant learner information.",
    indicator_1_7_s3: "There is a system in place to share relevant records and information when learners transition from one teacher/ class/ program to a new teacher/ class/ program to insure that the educational plan remains consistent despite staff change.",
    outcome_2_1: "Learners with disabilities actively participate in classroom and learning environments adapted to their needs.",
    outcome_2_2: "Learners have access to adapted resources that appropriately address their needs and strengths.",
    indicator_2_1_s1: "Indoor and outdoor spaces are safe and accessible for learners to move about as independently as possible.",
    indicator_2_1_s2: "Multiple learning spaces or locations are flexible and accessible within the program and used for teaching and learning.",
    indicator_2_1_s3: "Programs select spaces in the community that provide accessibility to all learners so all learners can participate and learn in natural environments, promoting teaching and learning anytime and anywhere.",
    indicator_2_2_s1: "The core program environment (e.g. school entrance, classroom(s), toilet(s)) are adapted for learners with physical disabilities so they can access with minimal support.",
    indicator_2_2_s2: "The broader program environment (including common areas) is adapted for learners with physical disabilities so they can acess with minimal support.",
    indicator_2_2_s3: "The environment is adapted to encourage active participation by  learners with physical disabilities.",
    indicator_2_3_s1: "Space and work areas are adapted to accommodate for learners’ visual needs.",
    indicator_2_3_s2: "Space and work areas are adapted to accommodate for individual  learners’ specific visual needs.",
    indicator_2_3_s3: "Amount of sensory input is controlled within the learning environment to encourage attention and maximum access to learning for individual  learners’ specific visual needs.",
    indicator_2_4_s1: "Space is adapted for learners’ hearing needs.",
    indicator_2_4_s2: "Space is adapted for individual learners’ specific hearing needs.",
    indicator_2_4_s3: "Amount of sensory input is controlled within the learning environment to encourage attention and maximum access to learning for individual learners’ specific hearing needs.",
    indicator_2_5_s1: "Simple adaptive devices are available and readily accessible to support learning (such as adapted chair, slant board, pencil grip, adapted spoon, picture communication board, etc.)",
    indicator_2_5_s2: "Accessible technology is available to support learning (such as communication devices, augmentative and alternative communication, screen readers, etc.)",
    indicator_2_5_s3: "Program staff have capacity to support learners in using technology for learning, including preparing materials and using technology in implementing lessons.",
    indicator_2_6_s1: "Adaptive learning resources required to access the curriculum, such as braille books, large print books, etc.  are available to learners.",
    indicator_2_6_s2: "Adaptive learning resources required to access the curriculum, such as braille books, large print materials, etc. are available to learners at the same time as their peers without disabilities.",
    indicator_2_6_s3: "Adaptive learning resources required to access the curriculum are appropriate for individual learners, meet the learning styles of individual learners and are available to learners at the same time as their peers without disabilities.",
    outcome_3_1: "Learners' needs/ strengths/ preferences/ interests and learning priorities are assessed regularly in a way that is appropriate for them.",
    outcome_3_2: "Learner's evolving needs/ strengths/ preferences/ interests and learning priorities are regularly incorporated to the IEP.",
    outcome_3_3: "The learner attends a program that complies with guidelines and policies of local educational authorities.",
    indicator_3_1_s1: "Developmental/educational assessment is completed at least once a year for each learner.",
    indicator_3_1_s2: "Team members work in a well-coordinated way (e.g., sharing information in advance, joint observation and discussion) to complete assessments of learners.",
    indicator_3_1_s3: "Assessment tools used are accessible and appropriate for learners with disabilities (for example, adapted for vision loss, adapted for hearing loss, adapted for multiple disabilities).",
    indicator_3_2_s1: "Assessment team members are comfortable communicating and interacting with learners with disabilities.",
    indicator_3_2_s2: "Assessments are conducted during natural routines of the day.",
    indicator_3_2_s3: "Assessments are conducted during regular routines of the day.",
    indicator_3_3_s1: "Program staff have access to and use any available vision and hearing assessments by qualified eye-care or hearing specialists (ophthalmologist, optometrist, audiologist, etc.). Medical diagnosis is not a requirement for a learner's access to school or program enrollment.",
    indicator_3_3_s2: "Program staff coordinate with family to facilitate annual vision and hearing assessments by qualified eye-care or hearing specialists (ophthalmologist, optometrist, audiologist, etc.). Medical diagnosis is not a requirement for a learner's access to school or program enrollment and there is no delay in intervention because of lack of medical exams.",
    indicator_3_3_s3: "A system is in place and implemented to conduct and monitor annual program vision and hearing screenings.",
    indicator_3_4_s1: "Program staff make informal observations of learners' sensory functioning (vision, hearing) and basic physical and educational adaptations based on their observations.",
    indicator_3_4_s2: "Functional sensory (vision, learning media and hearing) assessments are completed every year for each learner.",
    indicator_3_4_s3: "Functional sensory (vision, learning media and hearing) assessments are completed every year for each learner AND program staff apply findings of functional sensory assessments and monitors changes in the learner's sensory functioning throughout the year.",
    indicator_3_5_s1: "Assessment recommendations are integrated into the learner’s Individualized Education Plan (IEP).",
    indicator_3_5_s2: "Assessment recommendations are integrated into the learner’s Individualized Education Plan (IEP) and implemented in practice by the educators.",
    indicator_3_5_s3: "A collaborative decision making process is used by the IEP team to inform instruction and program decisions (e.g. team shares information and discusses goals and teaching strategies; this includes sharing information about learners' needs/ strengths/ preferences/ interests, priorities and goals, as well as participating in discussions regarding learners' preferences, interests and practices that support learning).",
    indicator_3_6_s1: "Progress monitoring data collection process is established (formal or informal process).",
    indicator_3_6_s2: "Ongoing progress monitoring data is collected on a regular basis.",
    indicator_3_6_s3: "Data from progress monitoring is used to make decisions in a timely manner about environmental or instructional adaptations and changes to individualized goals for learners.",
    indicator_3_7_s1: "Program staff are aware of, participate in training on, and receive guidance in implementation of Ministry of Education (or other relevant governmental agency) guidelines and policies related to  assesssment, IEP, and progress monitoring.",
    indicator_3_7_s2: "Program staff implement Ministry of Education (or other relevant governmental agency) guidelines and policies related to  assesssment, IEP, and progress monitoring.",
    indicator_3_7_s3: "Program staff implement  Ministry of Education (or other relevant governmental agency)  guidelines and policies related to  assesssment, IEP, and progress monitoring, adapting these to appropriately address the needs/ strengths/ preferences/ interests of individual learners.",
    outcome_4_1: "Learners develop communication through interactions in a communication-rich environment and with supportive communication partners.",
    outcome_4_2: "Every member of the program's community feels welcome.",
    outcome_4_3: "Learners have access to a calendar system with which to understand and anticipate their daily schedule, and anticipate and converse about their activities.",
    outcome_4_4: "Learners have full access to communication throughout their day.",
    indicator_4_1_s1: "Staff display a comfortable and mutually pleasant relationship with their learners.",
    indicator_4_1_s2: "Staff understand, acknowledge and respond to the communication of their learners",
    indicator_4_1_s3: "Staff are fluent in the modes of communication that are most appropriate for their learners (e.g. sign language, total communication, augmentative alternative communication, symbol systems, object/picture symbols, gestures, etc).",
    indicator_4_2_s1: "Staff create opportunities for and encourage positive interactions between learners.",
    indicator_4_2_s2: "Learners positively interact with each other.",
    indicator_4_2_s3: "Class members share or are aware of the communication support systems used by peers, and interaction, friendship, and collaboration among students are encouraged.",
    indicator_4_3_s1: "The program is welcoming to all learners, their families and the broader community.",
    indicator_4_3_s2: "There is a sense of belonging for all learners in the program community (e.g., playground, lunchroom, general education classrooms, library, extracurricular activities).",
    indicator_4_3_s3: "There is shared responsibility for all learners by all program staff (e.g., language used is \"our\" not \"your\").",
    indicator_4_4_s1: "The program vision/mission is inclusive of all learners, irrespective of background, attainment and disability, and reflects an inclusive perspective, understanding education as a right.",
    indicator_4_4_s2: "Information about the program is made accessible to all, irrespective of home language or disability, for example translated, brailled, taped, in large print, using sign language, using clear easy to understand language with visual supports when necessary, etc.",
    indicator_4_4_s3: "Information about the program is made accessible to all, irrespective of home language or disability, for example translated, brailled, taped, in large print, using sign language when necessary.",
    indicator_4_5_s1: "A calendar system or schedule is available in each class, although it may not be individualized or accessible for each learner.",
    indicator_4_5_s2: "Staff use calendar systems or accesible schedules to help learners anticipate and converse about activities",
    indicator_4_5_s3: "Individualized calendar systems or accessible schedules are developed and used for each learner.  Calendar systems and accessible schedules are designed with consideration of the learner’s vision, motor and communication abilities (examples, objects of reference, pictures, braille, print).",
    indicator_4_6_s1: "Staff are aware that simply using verbal communication strategies may not be sufficient for all learners and are beginning to offer a variety of options of communication systems according to their individual needs/ strengths/ preferences/ interests (i.e., verbal, sign, pictures, objects, etc).",
    indicator_4_6_s2: "Learners and staff have access to a meaningful communication system (i.e., verbal, sign, augmentative alternative communication, pictures, objects, etc).",
    indicator_4_6_s3: "The communication system is used by the learner consistently throughout the program day and across people and environments.",
    indicator_4_7_s1: "The teaching staff offer clear and simple instructions in a format that is most readily understandable by each learner.",
    indicator_4_7_s2: "Staff understand the communicative intent of challenging behaviors, and respond in an appropriate manner.",
    indicator_4_7_s3: "Staff are able to model the next higher level of communication, thus encouraging communication growth in their learners.",
    outcome_5_1: "Each learner has an Individualized Education Plan (IEP) that guides instruction.",
    outcome_5_2: "Learners participate in teaching activities and use materials that are both age appropriate and developmentally appropriate.",
    outcome_5_3: "Learners participate in teaching activities that are motivating and that build upon their own interests and likes.",
    outcome_5_4: "Learners are encouraged and supported to meaningfully participate in all instructional activities.",
    outcome_5_5: "Learners' development of life/vocational skills are addressed through their daily activities and incorporated in their transition plan.",
    outcome_5_6: "Learners receive appropriate instructional support to access curriculum across curriculuar areas according to their educational needs.",
    indicator_5_1_s1: "Learners have a written educational plan with individualized goals, although it may not be based on formal assessment.",
    indicator_5_1_s2: "Each learner has an Individualized Education Plan (IEP), which is based on assessment results.",
    indicator_5_1_s3: "Lesson plans, activities and teaching strategies (as both written and implemented) clearly relate to the learner’s goals and objectives contained in the IEP.",
    indicator_5_2_s1: "Activities and teaching materials (including books and literacy materials) are appropriate for the learners’ ages and levels of development.",
    indicator_5_2_s2: "Concepts, knowledge and skills are taught through activities and materials that are both age and developmentally appropriate.",
    indicator_5_2_s3: "Concepts, knowledge and skills are taught providing opportunties for expansion and generalization through appropriate materials, activities and natural settings.",
    indicator_5_3_s1: "Teaching strategies and activities are based on learner's prior knowledge and existing skills.",
    indicator_5_3_s2: "Staff use teaching activities and accessible materials that are motivating and associated with the interests of their learners.",
    indicator_5_3_s3: "Staff members follow and build on the learner’s interests.",
    indicator_5_4_s1: "Learners have opportunities for choice-making during the program day.",
    indicator_5_4_s2: "Teaching staff anticipate and bring support to respond to the needs and interests of the learners.",
    indicator_5_4_s3: "Activities and content are implemented through problem-solving situations that motivate the learner to participate, share and make choices.",
    indicator_5_5_s1: "Learners are provided adequate support in order to actively participate in some activities.",
    indicator_5_5_s2: "Program staff provide an appropriate level of support and assistance for completing a task (that is with a minimum amount of cues, and waiting to allow learners time to participate as independently as possible).",
    indicator_5_5_s3: "Each learner fully participates in all learning activities.",
    indicator_5_6_s1: "Learning experiences are functional and age appropriate.",
    indicator_5_6_s2: "Transition plans and goals are developed during person-centered planning processes and are based on learner choices, preferences, and interests, with family participation.",
    indicator_5_6_s3: "Supports and services are provided to implement the transition plan for learners.",
    indicator_5_7_s1: "Learners receive support from staff who have basic skills to meet their varied educational needs, such as motor, communication, mobility, etc.",
    indicator_5_7_s2: "Learners receive the appropriate level of support services necessary to meet their educational needs, support their learning and ensure access to education on equal terms (such as physical therapy, orientation and mobility, access to specialists who will serve as consultants to the teachers, sign language interpreters and communication development services, augmentative alternative communication, etc).",
    indicator_5_7_s3: "Learners receive instruction in the Expanded Core Curriculum (ECC). ECC includes: Compensatory Access, Sensory Efficiency, Assistive Technology, Orientation and Mobility, Independent Living, Social Interaction, Recreation and Leisure, Career Education, and Self-Determination.",
    indicator_5_8_s1: "Program staff are familiar with the National Curriculum and provide exposure to some learning opportunities related to the National Curriculum.",
    indicator_5_8_s2: "Program staff develop and implement learning opportunities related to the National Curriculum through a flexible curriculum.",
    indicator_5_8_s3: "Program staff ensure access to the national curriculum through a flexible, meaningful curriculum, implementing Universal dDesign for Learning principles and making reasonable adjustments and accommodations as  required.",
    indicator_5_9_s1: "The program staff is aware of each learner's current literacy and numeracy levels and staff provide exposure to literacy and numeracy learning opportunities.",
    indicator_5_9_s2: "Literacy and numeracy are addressed at an appropriate level for each learner, embedded in functional activities, and integrated across activities and disciplines.",
    indicator_5_9_s3: "Program staff align individual learners' literacy and numeracy goals and instruction with the National Curriculum.",
    outcome_6_1: "Learners' families and the program's staff communicate in a regular basis, promoting partnership between program staff and families.",
    outcome_6_2: "Learners' families communicate and interact with each other.",
    outcome_6_3: "Learners' needs/ strengths/ preferences/ interests and learning priorities are determined in collaboration with / and active engagement of family members.",
    outcome_6_4: "Learners' families, guardians and caregivers increase their knowledge and skills to support their active participation in the education of their child.",
    indicator_6_1_s1: "Families are included and invited to be involved in the program's environment/ activities.",
    indicator_6_1_s2: "Families are offered a variety of culturally and linguistically appropriate ways to be involved, such as observing, volunteering, and developing materials outside of the education environment.",
    indicator_6_1_s3: "Families are involved as partners on their child’s educational team (such as by being asked for their ideas and guidance, sharing important information,  identifying priorities and actively contributing to the development and evaluation of individualized goals for their children).",
    indicator_6_2_s1: "There is an effective system of home-program communication (home visits, communication books, WhatsApp messaging, etc.), so staff and families can keep each other well informed about the learner.",
    indicator_6_2_s2: "Information about the program and about strategies used with their child is shared with families in an easily understood manner (e.g., without jargon).",
    indicator_6_2_s3: "There is an effective mechanism to address conflicts between parents and program concerning complaints about learner IEP, placement, discipline, record, supports, services.",
    indicator_6_3_s1: "Staff follow up with parents if learners are regularly absent.",
    indicator_6_3_s2: "Staff follow up with parents if learners are regularly absent and support parents to make it possible for learners to attend school.",
    indicator_6_3_s3: "A home-school system is implemented in case the learner can´t attend regularly.",
    indicator_6_4_s1: "There are coordinated activities that promote interactions and networking among families.",
    indicator_6_4_s2: "Families and staff work together to coordinate activities that promote interactions and networking among families.",
    indicator_6_4_s3: "The program supports the development of family leadership.",
    indicator_6_5_s1: "Family members are informed of results of learner's assessments.",
    indicator_6_5_s2: "Family members are encouraged to provide information as part of the learner's assessments.",
    indicator_6_5_s3: "Family members are encouraged to actively share information and to express their expectations and feedback during the assessment process.",
    indicator_6_6_s1: "Training/ Introductory workshops are designed and provided for families who have children in the program.",
    indicator_6_6_s2: "Training is designed and provided to families specific to a learner’s IEP objectives, instructional strategies, and other topics/ needs identified by the family.",
    indicator_6_6_s3: "Families are actively involved in determing topics and types of trainings.",
    outcome_7_1: "Learners participate in a program that is committed to quality improvement.",
    outcome_7_2: "Learner's education is enhanced through participation in a consistent and appropriate program.",
    outcome_7_3: "Learners' quality education is enchanced by staff who communicate and collaborate",
    outcome_7_4: "The members of the program's community, their procedures and actions, demonstrate a shared philosophy of inclusive values.",
    outcome_7_5: "Learners' quality education is improved by the systematic professional development of their educators.",
    outcome_7_6: "Learners' quality education is enhanced by the collaboration with the government.",
    outcome_7_7: "Learners' quality education is enhanced by the collaboration with non-governmental and civil society organizations and colleges/universities.",
    indicator_7_1_s1: "Program heads are supportive of initiating and developing quality programs and services for learners.",
    indicator_7_1_s2: "Program heads are proactive and committed in the development of quality programs and services for learners.",
    indicator_7_1_s3: "Program heads have a clear orientation to a continuous development of quality programs and services for learners.",
    indicator_7_2_s1: "An orientation period for new staff is implemented in order to facilitate consistent and appropriate programming.",
    indicator_7_2_s2: "Coaching and mentoring are implemented to ensure transfer of knowledge ad skills to new staff, in order to facilitate consistent and appropriate programming.",
    indicator_7_2_s3: "Systems are in place to ensure learners participate in consistent and appropriate education programs.",
    indicator_7_3_s1: "Program staff and administrators communicate clearly with each other.",
    indicator_7_3_s2: "The staff collaborates and share responsibilities with each other regardless of their specific roles.",
    indicator_7_3_s3: "The staff works collaboratively for problem solving, shares responsibilities and provides feedbback to each other regardless of their specific roles.",
    indicator_7_4_s1: "Administration supports inclusion of all learners through providing time for team members to collaborate.",
    indicator_7_4_s2: "Administration supports inclusion of all learners through providing the whole educational community (e.g., administrators, general educators, special educators, family members, learners, related services, paraeducators, transportation, lunchroom and playground personnel, government and community health workers) with ongoing assistance to support inclusion.",
    indicator_7_4_s3: "Administration and management support inclusion of all learners by building an educational community based on inclusive policies, inclusive practices and inclusive culture.",
    indicator_7_5_s1: "Training opportunities and learning activities are planned for the staff, family members, and administrative personnel regarding how to work with learners and how to meet their specific needs/ strengths/ preferences/ interests.",
    indicator_7_5_s2: "Administrators encourage and support staff to share what they have learned in professional development activities with their colleagues in their own program.",
    indicator_7_5_s3: "Program staff participate in a professional learning community (a group that meets regularly, shares expertise, and works collaboratively to improve teaching  skills and learners' learninig).",
    indicator_7_6_s1: "There is an accessible collection of educational materials that are appropriate resources for program staff and are in a language that is accessible to them.",
    indicator_7_6_s2: "The program improvement plan includes professional development activities relevant to program staff serving learners with disabilities.",
    indicator_7_6_s3: "Program staff receive technical assistance and support in an organized way by someone with knowledge and skills in the education of learners with disabilities.",
    indicator_7_7_s1: "The program complies with local, regional and national Ministry of Education (or other relevant governmental agency) standards for administration and service delivery.",
    indicator_7_7_s2: "Program administrators coordinate with local, district, division, regional, and national level officers who are responsible for program monitoring.",
    indicator_7_7_s3: "Program administrators coordinate with local, regional and national Ministry of Education (or other relevant governmental agency) officers to facilitate and advocate for Ministry guidelines and policies that appropriately and flexibly address the learning needs/ strengths/ preferences/ interests of learners with disabilities.",
    indicator_7_8_s1: "The program interacts with non-governmental and civil society organizations and colleges/universities.",
    indicator_7_8_s2: "The program organizes activities with the support of non-governmental, civil society organizations and/or colleges/universities.",
    indicator_7_8_s3: "The program co-organizes activities with non-governmental, civil society organizations and/or colleges/universities."
  },
  validations: {
    generic_error: "An error has occurred. Please try again later.",
    required_field: "Required field",
    email_required: "Email is required",
    invalid_email: "Invalid email",
    password_required: "Password is required",
    user_required: "Email or user are required",
    no_data: "No data available",
    no_info: "No information available",
    no_info_loaded: "No information loaded",
    element_required: "You must assign at least one item.",
    year_range_invalid: "Select a start year and an end year (start cannot be later than end), or include all assessments of the program.",
    school_not_found: "School not found",
    no_data_school: "No schools found.",
    no_reports_country: "There are no reports assigned for this country.",
    no_reports_region: "There are no reports assigned for this region.",
    no_reports_zone: "There are no reports assigned for this zone.",
    no_files_loaded: "No files loaded",
    scores_saved_successfully: "Scores saved successfully",
    scores_must_add_up_to_100: "Scores must add up to 100",
    file_name_too_long: "File name too long",
    minimun_chars_3: "Please enter a minimum of 3 characters",
    too_many_chars: "Too many characters",
    link_recovery_sent: "Recovery link sent to the email address entered.",
    user_not_found: "User not found or invalid email address.",
    comment_added: "Comment added successfully.",
    comment_edited: "Comment edited successfully.",
    comment_deleted: "Comment deleted successfully.",
    error_page_title: "Page Not Found",
    error_page_description: "We couldn't find the page you are looking for",
    error_page_btn: "Back to home"
  },
  server_alerts: {
    user_deleted: "User deleted successfully.",
    assigned_country: "The country has been assigned correctly.",
    assigned_region: "The region has been assigned correctly.",
    assigned_zone: "The zone has been assigned correctly.",
    assigned_school: "The school has been assigned correctly.",
    school_deleted: "School deleted successfully.",
    region_deleted: "Region deleted successfully.",
    zone_deleted: "Zone deleted successfully.",
    country_deleted: "Country deleted successfully.",
    comment_deleted: "Comment deleted successfully.",
    evaluation_deleted: "Quality Improvement Process deleted successfully.",
    file_deleted: "File deleted successfully.",
    file_uploaded_success: "File uploaded successfully.",
    file_updated: "Description updated successfully.",
    upload_connection_error: "No se pudo procesar la informacion por problemas de conexion. Intente nuevamente en unos minutos",
    eliminated_area_country: "The country has been deallocated successfully.",
    eliminated_area_region: "The region has been deallocated successfully.",
    eliminated_area_zone: "The zone has been deallocated successfully.",
    eliminated_area_school: "The school has been deallocated successfully.",
    submitted_for_review: "The assessment stage has been successfully submitted for review",
    review_successful: "Assessment stage successfully reviewed",
    stage_review_cancelled: "Stage review successfully cancelled",
    stage_invalidated: "Stage validation successfully removed",
    action_plan_submitted_for_review: "The action plan has been successfully submitted for review",
    action_plan_review_successful: "Action plan successfully reviewed",
    action_plan_review_cancelled: "Action plan review successfully cancelled",
    toggle_enabled_ok: "Instrument successfully enabled/disabled",
    line_opened: "New assessment successfully opened",
    line_closed: "Assessment successfully closed",
    evaluation_line_closed_without_action_plan: "Assessment closed without action plan",
    unanswered_questions: "There are unanswered questions",
    undefined_objectives: "There must be at least 2 defined goals",
    activities_without_observations_results: "Activities must have observation and expected results",
    domain_result_needs_to_be_assigned: "There are goals that do not have a domain or assigned result",
    goals_without_actions: "There are goals without recorded actions",
    not_questions_associated: "There are no questions associated with the action plan",
    link_uploaded_success: "Link uploaded successfully",
    link_deleted: "Link deleted successfully",
    link_upload_failed: "Error uploading link",
    not_ready_files: "The minimum number of 2 evidence files per domain/category is not met",
    not_ready_results: "Results are missing for some indicators in this assessment cycle",
    not_ready_results_1: "Results are missing for some indicators in Stage 1",
    not_ready_results_2: "Results are missing for some indicators in Stage 2",
    not_ready_results_3: "Results are missing for some indicators in Stage 3",
    not_ready_demographics: "Student demographics are not complete",
    not_ready_comments: "Comments are missing for some indicators in this assessment cycle",
    not_ready_comments_1: "Comments are missing for some indicators in Stage 1",
    not_ready_comments_2: "Comments are missing for some indicators in Stage 2",
    not_ready_comments_3: "Comments are missing for some indicators in Stage 3",
    invalid_stage_review_ids: "One or more stages are invalid or cannot be submitted",
    cannot_review_own_submission: "You cannot review something you submitted for review yourself",
    cannot_review_own_evaluation: "You cannot review an assessment that you opened yourself",
    unauthorized_zone: "You are not assigned to this zone",
    action_plan_validated: "Action plan validated successfully",
    action_plan_reactivated: "Action plan reactivated successfully",
    action_plan_closed: "Action plan closed successfully",
    link_added: "Link added successfully",
    comment_updated: "Comment updated successfully",
    evaluation_finalized: "Quality Improvement Process finalized successfully",
    evaluation_reopened: "Quality Improvement Process reopened successfully",
    evaluation_line_deleted: "Assessment deleted successfully",
    evaluation_line_reopened: "Assessment reopened successfully"
  },
  server_errors: {
    invalid: "Invalid input",
    date_reorders_assessments: "This date would change the order of the assessments. Only administrators can do this.",
    no_links: "The action plan must have at least one link before closing.",
    actions_not_finished: "All activities must be completed or cancelled before closing the action plan.",
    no_admin_area: "Admin should not be assigned an area.",
    invalid_stat: "Invalid statistic type.",
    invalid_model: "Invalid model type.",
    user_no_permissions: "This user has no permissions to create super administrator.",
    comment_no_permissions: "You do not have permission to delete this comment.",
    comment_length: "Ensure this field has no more than 1000 characters.",
    file_no_permissions: "You do not have permission to delete this file.",
    comment_too_long: "The description must be at most 1000 characters long.",
    evaluation_no_permissions: "You do not have permission to assign a Quality Improvement Process to the selected school.",
    active_evaluation_exists: "This school already has an active Quality Improvement Process. The previous one must be finalized before creating a new one.",
    invalid_indiprint: "Scores must add up to 100.",
    region_existing_name: "This region already exists.",
    zone_existing_name: "This zone is already created in this country.",
    zone_no_permissions: "You do not have permissions to create a zone in the selected country.",
    school_existing_name: "This school is already created in this zone.",
    school_no_permissions: "You do not have permissions to create a school in the selected zone",
    password_not_equal: "Passwords do not match",
    incorrect_password: "The password entered does not match your current password. Please enter it again.",
    invalid_user_or_pass: "Invalid user or password.",
    min_length_username: "Ensure this field has at least 5 characters.",
    min_length_password: "Ensure this field has at least 8 characters.",
    min_length: "Ensure this field has at least 8 characters.",
    unique_email: "An account with this email address already exists.",
    invalid_email: "Please enter a valid email address.",
    unexpected_error: "An unexpected error occurred.",
    unique_username: "A user is already registered with this name.",
    instrument_not_found: "The selected instrument was not found.",
    permission_denied: "You do not have permission to perform this action.",
    instrument_not_enabled: "The selected instrument is not enabled to create Quality Improvement Processes.",
    indicator_not_found: "The indicator provided does not exist.",
    indicator_instrument_mismatch: "The selected indicator does not belong to the Quality Improvement Process instrument.",
    upload_error: "Error uploading file.",
    evaluation_line_not_found: "The assessment does not exist or is not in open status",
    unauthorized_school: "You do not have permission to act on this school",
    no_open: "The assessment is not in \"OPEN\" status",
    evaluation_without_country: "The country could not be determined",
    country_without_representative: "The country does not have an assigned representative",
    more_than_one_representative: "Configuration error: More than one representative found for the country",
    invalid_status_evaluation_line: "The assessment must be in \"IN REVIEW\" status to be reviewed",
    evaluation_id_required: "The Quality Improvement Process ID is required",
    previous_line_not_closed: "The previous assessment must be closed before opening a new one",
    lines_not_closed: "All assessments must be completed, validated and closed",
    action_plans_not_validated: "All associated action plans must be validated",
    no_evaluation_lines: "The Quality Improvement Process has no assessments",
    already_finished: "The Quality Improvement Process is already finalized",
    not_finished: "The Quality Improvement Process is not finalized",
    evaluation_line_not_found_closed: "The assessment does not exist or is not closed",
    no_line_to_close: "No assessment was found to close",
    not_validated: "Only a validated assessment can be closed",
    invalid_status_line: "Invalid status. Only \"OPEN\" or \"CLOSED\" is allowed",
    evaluation_not_found: "The specified Quality Improvement Process does not exist",
    link_limit: "No more than 5 links can be added to this assessment",
    file_limit: "No more than 5 files can be added to this assessment",
    file_type_not_allowed: "This file type is not allowed.",
    file_size_exceeded: "The file exceeds the maximum size allowed for its type.",
    evaluation_line_closed: "A closed assessment cannot be deleted",
    evaluation_line_in_review: "The assessment cannot be deleted while a stage is in review",
    evaluation_has_open_lines: "Cannot open a new assessment because the Quality Improvement Process has assessments that are not closed",
    evaluation_line_not_found_open: "The assessment does not exist or is not in open status",
    stage_not_validated: "The current stage has not been validated yet",
    incomplete_results: "Not all enabled indicators have a result",
    missing_comments: "Not all enabled indicators have a comment",
    not_last_line: "Only the last assessment can be reopened",
    evaluation_line_has_action_plan: "The assessment already has an action plan",
  }
};
